/**
 * Created by amu33 on 26/09/2016.
 */
import React from "react";
import SocialMenuItem from './social-menu-item.jsx';
/**
 * Social Menu
 * @returns the layout of a Social Menu
 * @constructor
 */
const SocialMenu = ({items}) => {
    var itemMap = items.map(function(item, index){
        return (<li key={index} className={item.type}>
                    <SocialMenuItem type={item.type} url={item.url} icon={item.icon} />
                </li>);
    });
    return (
        <nav className="social-nav">
            <ul>{itemMap}</ul>
        </nav>
    );
};

SocialMenu.propTypes = {
    items: React.PropTypes.array.isRequired
};

export default SocialMenu;



/** WEBPACK FOOTER **
 ** ./app/components/social-menu/social-menu.jsx
 **/